<template>
	<el-container class="cl-table" style="height:500px">
		<el-main style="height:460px" id="main_yzz">
			<el-table
					v-loading="loading_yzz"
				:data="tableData"
				:height="460"
				style="width: 100%; border-right:none"
				:stripe="true"
				:border="true"
				size="mini"
				header-row-class-name="table-header-row"
				header-cell-class-name="table-header-cell"
		>数据预览
			<template v-for="(item) in fields">
				<el-table-column
						:prop="item.key"
						:label="item.key"
						:show-overflow-tooltip="true"
				class="">
				</el-table-column>
			</template>
		</el-table>
		</el-main>
	</el-container>
</template>

<script>
	export default {
		props:['datas'],
		data(){
			return {
				loading_yzz:true,
				fields:[],
				tableData: []
			}
		},
		methods: {

		},

		computed: {

		},
		created: function () {
			const that = this;
			const da={
                criteriaSearchId:this.datas.criteriaSearchId,
                criteriaSql:this.datas.criteriaSql,
				da1:this.datas.searchId,
				da2:this.datas.shSql,
				da3:this.datas.shParam
			}

			this.request.get('/bigdata-visual/modelData/shApi/querySql',da).then(res => {
                if (res.status === 1) {
                    that.tableData = res.data[0].content;
                    let files=[];
                    if (that.tableData!=null&&that.tableData.length>0){
                        let obj = this.tableData[0];
                        for (let i in obj) {
                            files.push({key:i})
                        };
                    }
                    that.fields = files;
                } else if (res.status === 0) {
                    this.$message.error(res.msg ? res.msg : '系统异常');
                }
				that.loading_yzz = false;
			})
		}
	}
</script>
<style lang="less">
	.cl-table {
		background-color: #FFFFFF !important;
		border: 0;
		height: 100%;
	.el-header {
		background-color: #FFFFFF;
		padding: 0px;
	.toolbar {
		text-align: left;
	.buttons {
		margin-right: 20px;
	.fas {
		margin-right: 0;
	}
	}
	.filter {
	}
	}
	.searchbar {
		text-align: right;
	}
	}
	.el-main {
		background-color: #FFFFFF;
		padding: 0px;
		height: calc(100vh - 270px);
		margin: 20px 0px;
	.el-table {
	.table-header-row {
	.table-header-cell {
		background-color: #E9EEF3;
		border-color: #fff;
		font-weight: bold;
		color: #515a6e;
	}
	}
	}
	}
	.el-footer {
		background-color: #FFFFFF;
	.pagination {
		text-align: left;
	.el-pagination {
	.el-pager {
	.number {
		margin: 0px 3px;
	}
	}
	}
	}
	.toolbar {
		text-align: right;
	}
	}
	.actionBox {
		font-size: 14px;
	> i {
		margin-right: 4px;
		margin-left: 4px;
		border: none;
		box-sizing: border-box;
		height: 14px;
		display: block;
		cursor: pointer;
	&:before {
		 text-align: center;
		 width: 100%;
		 display: inline-block;
		 margin: 0 auto;
	 }
	}
	}
	}

	.tools_contianer {
		display: inline-block;
	}

	//分页高亮和hover颜色
	  .el-pagination.is-background .el-pager li:not(.disabled):hover {
		  color: #409EFF;
	  }
	.el-pagination.is-background .el-pager li:not(.disabled).active{
		background-color: #409EFF;
		color: #fff;
	}
	//信息库table
	  .lay-table{
		  height: 100%;
	.cl-table .el-main{
		height: calc(100vh - 330px);
	}
	}
	//业态详情表单
	  .margin-height{
		  margin-top: 15px;
	  }

	.cl-table .el-button span{
		margin-right: 0px !important;
	}
	#main_yzz .el-loading-spinner{
		width: 970px;
	}
</style>